export const StageConfig = {
  /** Number of blocks in the tower (excluding daruma head) */
  blockCount: 5,
  /** Block width in pixels */
  blockWidth: 120,
  /** Block height in pixels */
  blockHeight: 40,
  /** X distance from center for a block to be considered "escaped" */
  escapeXThreshold: 250,
  /** Tilt angle threshold in radians (~17 degrees) for game over */
  tiltThreshold: 0.3,
  /** Minimum swipe distance in pixels to register */
  minSwipePx: 30,
  /** Maximum swipe distance in pixels (clamped) */
  maxSwipePx: 300,
  /** Matter.js gravity */
  gravity: { x: 0, y: 1 },
  /** Impulse strength multiplier */
  impulseMultiplier: 0.015,
  /** Block friction */
  blockFriction: 0.8,
  /** Block restitution (bounciness) */
  blockRestitution: 0.05,
  /** Daruma head size (width, height) */
  darumaHeadWidth: 80,
  darumaHeadHeight: 60,
} as const;
